import Vue from 'vue'
import Glide from '@glidejs/glide'
Vue.prototype.$eventHub = new Vue();

if (document.getElementById('vue-single-realisation')) {
  new Vue({
    el: '#vue-single-realisation',
    data() {
      return {
        isOpen: false,
      }
    },
    mounted() {
      
      const CustomLength = function(Glide, Components, Events) {
        return {
          mount () {
            Events.emit('slider.length', Components.Sizes.length)
          }
        }
      }

      let slides = [...document.getElementsByClassName('glide__slide')]
      let autoplayValue = (slides.length == 1)? false : 4000
      const config = {
        autoplay: autoplayValue,
        animationDuration: 1000,
        animationTimingFunc: 'ease',
        perView: 1,
        type: "carousel"
      };
      let glide = new Glide('.js-glide-realisation', config)

      if (document.getElementById('index-realisations')) {
        let index = document.getElementById('index-realisations')
        glide.on("move", () => index.innerText = glide.index + 1)
      }  

      glide.on('slider.length', (length) => {
        if(length <= 5){
          glide.disable()
        }
      })
      glide.mount({
        CustomLength
      })

    },
    methods: {
      openModal () {
        this.$eventHub.$emit('modal:realisation:open')
        setTimeout(() => {
          this.initCarouselModal()
        }, 500);
      },
      initCarouselModal () {
        new Glide('.js-glide-realisation-modal', {
          animationDuration: 1000,
          animationTimingFunc: 'ease',
          perView: 1,
          peek: 340,
          type: "carousel"
        }).mount()
      }
    }
  })
}